export function getBriefStatus(currentBrief) {

  const isBriefActive = currentBrief && !currentBrief.get('removed') ? true : false;
  const isBriefApproved = currentBrief && currentBrief.get('approved') ? true : false;

  return briefStatus(isBriefActive, isBriefApproved);
}

function briefStatus(isBriefActive, isBriefApproved) {
  if (!isBriefActive && !isBriefApproved) return 'incomplete';
  if (isBriefActive && !isBriefApproved) return 'pending';
  if (isBriefActive && isBriefApproved) return 'complete';
}

export function getContractStatus(currentContract, signedContract) {

  const isContractActive = currentContract && !currentContract.get('removed') ? true : false;
  const isSignedContractActive = signedContract && !signedContract.get('removed') ? true : false;

  return contractStatus(isContractActive, isSignedContractActive);
}

function contractStatus(isContractActive, isSignedContractActive) {
  if (!isContractActive) return 'incomplete';
  if (isContractActive && !isSignedContractActive) return 'pending';
  if (isContractActive && isSignedContractActive) return 'complete';
}



/** WEBPACK FOOTER **
 ** ./src/utils/document-status-functions.js
 **/